import { createContext, useContext, useState, ReactNode } from "react";
import { User } from "@/bryntum-lib/models/User";
import { UserEditorProps } from "../UserEditor";
import { useSwivuStore } from "@/react/hooks/useSwivuStore";
import { STORE_KEYS } from "@/other/constants/StoreKeys";

interface UserEditorContextValue {
  userRecord: User;
  onClose: () => void;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  editorInstance: UserEditorProps["editorInstance"];
}

const UserEditorContext = createContext<UserEditorContextValue | undefined>(undefined);

export const useUserEditorContext = () => {
  const context = useContext(UserEditorContext);
  if (!context) {
    throw new Error("useUserEditorContext must be used within UserEditorProvider");
  }
  return context;
};

interface UserEditorProviderProps {
  children: ReactNode;
  userRecord: User;
  onClose: () => void;
  record: UserEditorProps["record"];
  editorInstance: UserEditorProps["editorInstance"];
}

export const UserEditorProvider = ({ children, userRecord, onClose, record, editorInstance }: UserEditorProviderProps) => {
  useSwivuStore<User>({ storeId: STORE_KEYS.boardUserStore, subscriberFn: ({ record: changedRecord }) => userRecord.isPhantom || (changedRecord.id === userRecord.id) });
  const [activeTab, setActiveTab] = useState(record?.selectTabByTypeOnOpen || "general");

  return (
    <UserEditorContext.Provider
      value={{
        userRecord,
        onClose,
        activeTab,
        setActiveTab,
        editorInstance
      }}
    >
      {children}
    </UserEditorContext.Provider>
  );
};
